module.exports = __webpack_public_path__ + "static/img/1.91a44bf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/eng/1.png
// module id = wgub
// module chunks = 0